import React from 'react';
import Layout from '../components/layout';
import {Link} from 'gatsby'
import styled from 'styled-components'
import CoverImage from '../components/CoverImage/CoverImage';


const Pagination = styled.div`

    display: flex;
    justify-content: center;
    
`



const PaginationItem = styled.div`

    border: 1px solid #dee2e6;
    background-color: ${props => props.isCurrentPage ? 'blue' : 'white'}
`

const PageNumber = styled(Link)`
    display: block;
    
`

const featured_media = (image) => {
    let source_url
    if (!image) {
        source_url = "https://smorasstats.com/v4/wp-content/uploads/2020/04/meadow-grass-sunshine-wide-scaled.jpg"
    } else {
        source_url = image.source_url
    } 
    return source_url;
}



export default ({pageContext}) => (
    <Layout>
        <CoverImage image="https://smorasstats.com/v4/wp-content/uploads/2020/04/meadow-grass-sunshine-wide-scaled.jpg" text="Innlegg" />
        <div className="container">
        {pageContext.posts.map(post => (
            <>
            <div key={post.node.wordpress_id} className="row mb-4 mt-4">
                <div className="col-lg-6 col-xl-5">
                    <img className="img-fluid" src={featured_media(post.node.featured_media)} alt={post.node.title} />
                </div>
                <div className="col-lg-6 col-xl-7">
                    <p className="text-success font-weight-bold">
                        <small>
                        {post.node.categories.map(category => (
                        <span>
                            <strong>{category.name} </strong>
                        </span>
                        ))}
                        </small>
                    </p>
                    <h2 dangerouslySetInnerHTML={{__html: post.node.title}} />
                    <p dangerouslySetInnerHTML={{__html: post.node.excerpt}} />
                    <p className="text-danger"><small>Av <strong>{post.node.author.name}</strong> den {post.node.date}</small></p>
                    <Link to={'innlegg/' + post.node.slug + '#start'} className="btn btn-success">Les mer</Link>
                </div>
            </div>
            <hr />
            </>
            
        ))}
        <Pagination className={'pagination p-4'}>
            <PaginationItem className="page-item">
                
                <PageNumber className="page-link" to={pageContext.currentPage === 2 ?  '/innlegg#start' : `/innlegg/${pageContext.currentPage-1}`}>
                    {pageContext.currentPage < 2 ?  '' : `Forrige`}
                </PageNumber>
            </PaginationItem>
            {Array.from({length: pageContext.numberOfPages}).map((page, index) => (
                
                
                <PaginationItem className={index+1 === pageContext.currentPage ? 'page-item active' : 'page-item'} key={index} isCurrentPage={index + 1 === pageContext.isCurrentPage}>
                    <PageNumber className={'page-link'} to={index === 0 ? '/innlegg#start' : `/innlegg/${index + 1}#start`}>                            
                        {index + 1}
                    </PageNumber>
                </PaginationItem>
                
                
                
            )) }
            <PaginationItem className="page-item">
                <PageNumber 
                    className="page-link" 
                    to={pageContext.currentPage === pageContext.numberOfPages ? `/innlegg/${pageContext.currentPage}` : `/innlegg/${pageContext.currentPage+1}`}>
                        {pageContext.currentPage === pageContext.numberOfPages ? "" : "Neste"}
                </PageNumber>
            </PaginationItem>
        </Pagination>
        </div>
    </Layout>
)